import * as React from 'react';
import { ContactPage } from "./Page";

export const getRoutes = () => {
    return [{
        path: "contact",
        element: <ContactPage />,
    }];
};